// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"36a57211","498":"8f3aa411","703":"9909915b"}[chunkId] + ".chunk.js";
};